import classNames from "classnames"

import { Color } from "../../../../constants/V2/color"
import Typography from "../Typography"

import React from "react"

const SIZE_CLASSES = {
  sm: { dot: "h-16 w-16", inner: "h-[6px] w-[6px]" },
  md: { dot: "h-20 w-20", inner: "h-[8px] w-[8px]" },
}

type Props = {
  id: string
  name?: string
  value?: string
  checked?: boolean
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void
  className?: string
  size?: "sm" | "md"
  label?: string
  labelColor?: Color
}

const Radio = ({
  id,
  name,
  value,
  checked = false,
  onChange,
  className,
  size = "sm",
  label,
  labelColor = Color.Black,
}: Props) => {
  const { dot, inner } = SIZE_CLASSES[size]

  return (
    <div className={classNames("group flex-shrink-0", className)}>
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        onChange={onChange}
        className="sr-only"
        aria-checked={checked}
      />
      <label htmlFor={id} className="flex cursor-pointer items-center">
        <div className={classNames("relative block flex-shrink-0", dot)}>
          <div
            className={classNames(
              "absolute inset-0 rounded-full border border-charcoal/20 transition-opacity duration-200 group-hover:border-charcoal/60",
              checked ? "opacity-0" : "opacity-100"
            )}
          />
          <div
            className={classNames(
              "absolute inset-0 rounded-full bg-blue transition-opacity duration-200",
              checked ? "opacity-100" : "opacity-0"
            )}
          >
            <div
              className={classNames(
                "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-white transition-opacity duration-200",
                inner
              )}
            />
          </div>
        </div>
        {label && (
          <Typography
            color={labelColor}
            text={label}
            font="grotesk"
            size="body-md"
            weight="book"
            className="ml-10 mt-[2px]"
          />
        )}
      </label>
    </div>
  )
}

export default Radio
